module.exports = __webpack_public_path__ + "img/img24.0f337d22.svg";